/**
 * Utility class to be used across all the components for perfoming various utility tasks
 */
import auth from '../common/auth';
import Constants from '../common/constants';

export default class Utils {
    static getProfileName(athlete: any, profleinfo: Array<any>) {
        let profileName = '';
        if (athlete.firstname && athlete.lastname) {
            profileName = athlete.firstname + ' ' ;
            let middleName = Utils.getProfileValue(profleinfo, 'middlename');
            profileName += middleName && middleName.trim() !== '' ? 
                                middleName + ' ' + athlete.lastname : athlete.lastname;                                
        }        
        return profileName;
    }

    static getProfileValue(profleinfo: Array<any>, property: string) {
        let value = '';
        profleinfo.forEach( element => {
            if ( element.playerinfoname === property ) {
                value = element.playerinfovalue;
            }
        });
        return value;
    }

    static getGender(gender: string) {
        return gender === '0' ? 'Female' : gender === '1' ? 'Male' : '';
    }

    static getConcussed(concussed: boolean) {
        return concussed === false ? 'No' : 'Yes';
    }

    static getDate(date: string) {
        let d = new Date(date);
        let day: string = (d.getDate() < 10) ? '0' + d.getDate().toString() : d.getDate().toString();
        let month: string = ((d.getMonth() + 1) < 10) ? '0' + (d.getMonth() + 1).toString() : 
                                                    (d.getMonth() + 1).toString();
        return month + '/' + day + '/' + d.getFullYear();
    }    
        
    static getDateFromTimestamp(date: string) {
        let d = new Date(parseInt(date, 10));
        let day: string = (d.getDate() < 10) ? '0' + d.getDate().toString() : d.getDate().toString();
        let month: string = ((d.getMonth() + 1) < 10) ? '0' + (d.getMonth() + 1).toString() : 
                                                    (d.getMonth() + 1).toString();
        return month + '/' + day + '/' + d.getFullYear();
    }    

    static getDateInFormart(date: string) {
        let d = new Date(date);
        console.log(d);
        return d.getFullYear() + '-' + (d.getMonth() + 1)  + '-' + d.getDate();
    }

    static getTime(date: string) {
        let d = new Date(date);
        return (d.getHours() < 10 ? '0' + d.getHours() : d.getHours()) 
                + ':' + (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes())
                + ':' + (d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds());
    }

    static dataDiff(date1: string, date2: string) {
        let d1 = new Date(date1);
        let d2 = new Date(date2);
        return d1.getTime() - d2.getTime();
    }

    static resetScroll() {
        let layoutHtml: any = document.getElementById('layout');
        if (layoutHtml !== null ) {
            layoutHtml.scrollTop = 0;
        }
    }

    static isObjectEmpty(obj: any): boolean {
        let cols = Object.keys(obj);
        let isEmpty = true;
        cols.map((colName: string) => {
            if (obj[colName] instanceof Array) {
                isEmpty = isEmpty ? obj[colName].length === 0 : isEmpty;
            } else {
                isEmpty = isEmpty ? obj[colName] === '' || obj[colName] === undefined : isEmpty;
            }
        });
        return isEmpty;
    }

    static cascadeStringCase(strToCascade: string): string {
        if (strToCascade !== null) {
            let cascadedString = '';
            let str = strToCascade.trim().replace(' ', ',');
            let words: any = [];
            words = str.trim().split(',');
            if (words.length > 0) {
                words.forEach((w: string) => {
                    cascadedString += w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() + ' ';
                });
                return cascadedString.trim();
            } else {
                return strToCascade.charAt(0).toUpperCase() + strToCascade.slice(1).toLowerCase();
            }
        } else {
            return '';
        }
    }

    static getRoleValue(roleid: number): string {
        let rolename: any = Object.keys(auth.getRoles()).filter( (value, index) => {
            if (auth.getRoles()[value] === roleid) {
                return true;
            } else { return false; }
        });
        return this.cascadeStringCase(rolename.toString().replace(new RegExp('_', 'g'), ' ')); 
    }

    static formatNumber(score: number, precision: number) {
        if (score !== undefined) {

            if (navigator.language !== 'es') {// other than spanish locale
                return score.toFixed(precision);
            }

            /*Spanish use a comma for decimals, and break up large numbers with dots – or alternatively, 
            they put a space between every three digits. 
            So "1048710123901" would be written as “1.048.710.123.901” (or “1 048 710 123 901”) 
            and "0.5" would be “0,5”.*/
            let scoreWithPrecision = score.toFixed(precision);
            let index = scoreWithPrecision.indexOf('.');
            let fraction = scoreWithPrecision.substr(index + 1, scoreWithPrecision.length - index);
            let scoreWtihoutPrecision = scoreWithPrecision.substr(0, index); 
            var outScore = scoreWithPrecision;

            if (scoreWtihoutPrecision.length >= 4) { // if more than 4 digits               
                let scoreArr = scoreWtihoutPrecision.match(/.{4}/g); // every fourth character length                  
                if (scoreArr !== undefined || scoreArr !== null ) {   
                    let scoreArrLen = scoreArr!.join().length;
                    let strLen = scoreWtihoutPrecision.length;
                    if (scoreArrLen < strLen) {
                        let remainder = scoreWtihoutPrecision.substr(scoreArrLen, strLen - scoreArrLen);
                        outScore = scoreArr!.join('.') + '.' + remainder + ',' + fraction;
                    }
                                   
                    outScore = scoreArr!.join('.') + ',' + fraction;

                    // adding initial dot seperator after first digit.
                    outScore = outScore.substr(0, 1) + '.' 
                                        + outScore.substr(1, outScore.length - 1);
                }        
                                  
            }

            return outScore;

        } else {
            return '0';
        }

    }

    // static decodeToken(token: any) {
    //     if (token !== undefined) {
    //       let base64Url = token.split('.')[1];   
    //       let base64 = base64Url.replace('-', '+').replace('_', '/');
    //       return JSON.parse(window.atob(base64));
    //     }
    // }

    static getLocalizedTestType(type: string) {
        let testTypes: any = Constants.getTestTypes();
        return testTypes[Constants.getIndexForDBTestType(type)];
    }

    static validateEmail(email: any) {
        // let re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let re = /^[a-zA-Z0-9]\S+@\S+\.\S+(.*[a-zA-Z])$/;
        return re.test(email);
    }

    static validatePhone(phone: any) {
        // let re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        // let re = /^(\+?\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;       
        // return re.test(phone);
        return phone.replace(/\D/g, '').length >= 7;
    }

    static validatePassword(password: string) {
        var re = /(?=.*\d)(?=.*[a-z]).{7,}/;
        let result = re.test(password);
        console.log(result);
        return result;
    }

    static getRandomAlphaNum() {
        return Math.random().toString(36).substr(2, 5);
    }
}


// WEBPACK FOOTER //
// ./src/components/common/utils.tsx